import React from 'react';
import type { Modifier as _Modifier, ModifierGroup } from 'root/apiTypes';
import { classes } from './ModifierGroups.st.css';
import { dataHooks } from 'root/dataHooks';
import { Modifier } from 'root/components/Menus/Modifier/Modifier';
import { useModifierGroupsLogic } from './ModifierGroups.logic';
import { Text, TextButton, TextButtonPriority } from 'wix-ui-tpa/cssVars';

export const ModifierGroups = ({ modifierGroups }: { modifierGroups: ModifierGroup[] }) => {
  const {
    modifierGroupTitleHtmlTag,
    showButtonText,
    onChangeShowButton,
    shouldShowModifierGroup,
    shouldShowModifier,
    shouldShowShowButton,
    shouldRefFocus,
    firstShowMoreElementRef,
  } = useModifierGroupsLogic(modifierGroups);
  return (
    <div className={classes.modifierGroups} data-hook={dataHooks.item.modifierGroups} role="list">
      <div className={classes.modifierGroupList}>
        {modifierGroups.map(
          (modifierGroup: ModifierGroup, modifierGroupIndex: number) =>
            shouldShowModifierGroup(modifierGroupIndex) && (
              <div key={modifierGroup?.id} className={classes.modifierGroup}>
                <div
                  ref={shouldRefFocus(modifierGroupIndex) ? firstShowMoreElementRef : undefined}
                  className={classes.modifierGroupName}
                  tabIndex={0}
                >
                  <Text
                    data-hook={dataHooks.modifierGroup.name(modifierGroupIndex)}
                    tagName={modifierGroupTitleHtmlTag}
                  >
                    {modifierGroup?.name}
                  </Text>
                </div>
                <div className={classes.modifiers}>
                  {modifierGroup.modifiers?.map(
                    (modifier: _Modifier, modifierIndex: number) =>
                      shouldShowModifier(modifierIndex) && (
                        <Modifier
                          key={modifier.id}
                          modifier={modifier}
                          reference={
                            shouldRefFocus(modifierGroupIndex, modifierIndex) ? firstShowMoreElementRef : undefined
                          }
                        />
                      )
                  )}
                </div>
              </div>
            )
        )}
      </div>
      {shouldShowShowButton && (
        <TextButton
          className={classes.showButton}
          data-hook={dataHooks.modifierGroup.showButton}
          priority={TextButtonPriority.primaryLink}
          onClick={onChangeShowButton}
        >
          {showButtonText}
        </TextButton>
      )}
    </div>
  );
};
